// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"c599a8dd78ed009405e4","678":"0ef5cca3ddda7b0b2958","682":"f4bfaba37b0c15645941","883":"5abdfb7d8552a91b8d91"}[chunkId] + ".js";
};